import { listResource } from './listResource';

export async function listSpecialistsReport(options = {}) {
  return listResource('/admin/reports/specialists', options);
}

export async function listPatientsReport(options = {}) {
  return listResource('/admin/reports/patients', options);
}